import type { LicensedProducts } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const hasJpdLicense = (licensedProducts: LicensedProducts) =>
	licensedProducts['jira-product-discovery'] === true;
